// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emphasized[data-v-1d54cba2]{color:red}.fku-novelty-container[data-v-1d54cba2]{border:1px solid #000}.border-grey[data-v-1d54cba2]{border-bottom:2px solid #e0e0e0}.novelty-name[data-v-1d54cba2]{font-weight:700;font-size:1.2em}", ""]);
// Exports
module.exports = exports;
